export const ThreeLineHorizontalIcon = ({
  color = 'currentColor',
  size = '24',
  ...otherProps
}: {
  size?: number | string
} & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden={otherProps['aria-label'] ? undefined : 'true'}
      {...otherProps}
    >
      <path d="M5 6h14M5 12h14M5 18h14" />
    </svg>
  )
}
